<template>
<div class="chapter">
<div class="inner_page">
<h1><a id="page_16"></a><span class="caps">Love For Sale</span></h1>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 11_part03.vue?081fc3aa